import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import BusinessIcon from '@mui/icons-material/Business';
import { useNavigate } from 'react-router-dom';
import { useBusiness } from '../contexts/BusinessContext';
import { useSettingsDialog } from '../contexts/SettingsDialogContext';

const SubscribeToContinue: React.FC = () => {
  const navigate = useNavigate();
  const { selectedBusinessId } = useBusiness();
  const { openSettings } = useSettingsDialog();

  const hasBusiness = !!selectedBusinessId;

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh" p={3}>
      <Paper sx={{ p: 4, maxWidth: 480, textAlign: 'center' }}>
        {hasBusiness ? (
          <>
            <LockIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Subscription Required
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Your business doesn't have an active subscription. Choose a plan to
              keep using the site.
            </Typography>
            <Button variant="contained" onClick={() => openSettings('billing')}>
              Subscribe to Continue
            </Button>
          </>
        ) : (
          <>
            <BusinessIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              No Business Yet
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              You'll need to add or join a business before you can subscribe and
              start using the site.
            </Typography>
            <Button variant="contained" onClick={() => navigate('/businesses')}>
              Add or Join a Business
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default SubscribeToContinue;
